import 'slick-carousel'
import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'
import FButton from '~/js/components/button'
import FModal from '~/js/components/modal'
import FProductCard from '~/js/components/productCard'
import FSlider from '~/js/components/slider'
import { isIndexPage } from '~/js/helpers/page-helper'
import { getItemsFromIds, getRecentProductIds } from '~/js/helpers/getProducts'

const CLASS_NAME_RECENT_ITEMS = 'js-sections-recent-items'

document.addEventListener('DOMContentLoaded', () => {
  const elementsRecentItems = document.getElementsByClassName(
    CLASS_NAME_RECENT_ITEMS
  )
  if (!elementsRecentItems.length) return

  const recentProductIds = getRecentProductIds()
  Array.from(elementsRecentItems).forEach(async (element) => {
    if (!recentProductIds.length) {
      element.remove()
    }

    const { productMax, columnsSp, columnsPc, rowsSp, rowsPc } = element.dataset

    const productCount = Math.min(productMax, recentProductIds.length)
    const columns = isDesktop() ? columnsPc : columnsSp
    const rows = isDesktop() ? rowsPc : rowsSp

    const getProducts = async (productCount, page = 0) => {
      return await getItemsFromIds(
        recentProductIds.slice(page * productCount, (page + 1) * productCount)
      )
    }

    let products = []
    let hasError = false

    try {
      products = await getProducts(isDesktop() ? productCount : columns * rows)
    } catch (_) {
      hasError = true
    }

    if (!products.length) element.remove()

    createApp({
      name: 'SectionsRecentItems',
      components: {
        FButton,
        FModal,
        FProductCard,
        FSlider,
      },
      data() {
        return {
          columns,
          hasError,
          selectedIndex: 0,
          showReview: !isIndexPage,
          showCartButton: !isIndexPage,
          isDesktop: isDesktop(),
          isProcessing: false,
          products: products.filter((v) => v),
          page: 0,
        }
      },
      computed: {
        hasMore() {
          return this.products.length < productCount
        },
        narrow() {
          return !this.isDesktop && this.columns > 2
        },
      },
      mounted() {
        window.zvRenderReviewSummary(element)

        // SPの場合に実行、PCでは ComponentSlider で縦幅調整
        if (this.$refs.list) {
          const elementsCard =
            this.$refs.list.querySelectorAll('.c-product-card')
          let maxHeight = 0
          this.$nextTick(() => {
            maxHeight = Array.from(elementsCard).reduce(
              (maxHeight, element) => {
                element.style.height = 'auto'
                return Math.max(element.clientHeight, maxHeight)
              },
              0
            )
          })
          elementsCard.forEach((element) => {
            element.style.height = `${maxHeight}px`
          })
        }
      },
      methods: {
        async getProducts() {
          this.isProcessing = true
          this.page++
          try {
            const products = await getProducts(columns * rows, this.page)
            this.products = [...this.products, ...products]
            this.hasError = false
          } catch (e) {
            this.hasError = true
            console.error(e)
          }
          this.isProcessing = false
        },
        async retry() {
          await this.getProducts()
        },
      },
    }).mount(element)
  })
})
